import {
  createApi,
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError
} from '@reduxjs/toolkit/query/react';
import {
  selectCurrentErikToken,
  selectCurrentErikUrl,
  setAIAgentCredentials
} from '../../features/authSlice';
import type { RootState } from '../../store';
import LogRocket from "logrocket";
import _ from "lodash";
import {Modal} from "antd";

const serverError = _.debounce((title: string, content: string) => Modal.error({
  title,
  content
}), 100);

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const state = api.getState() as RootState;
  let token = selectCurrentErikToken(state);
  let baseUrl = selectCurrentErikUrl(state) ?? 'https://localhost';

  // Funzione per creare sempre una nuova istanza con token aggiornato
  const createRawBase = (currentToken: string | null, currentBaseUrl: string) =>
    fetchBaseQuery({
      baseUrl: currentBaseUrl,
      prepareHeaders: headers => {
        if (currentToken) headers.set('authorization', `JWT ${currentToken}`);
        return headers;
      }
    });

  let result = await createRawBase(token, baseUrl)(args, api, extraOptions);

  if (result.error?.status === 401) {
    const refreshBase = fetchBaseQuery({
      baseUrl: process.env.REACT_APP_API_URL,
      prepareHeaders: (headers, { getState }) => {
        const apiToken = (getState() as RootState).auth.token;
        if (apiToken) headers.set("authorization", `JWT ${apiToken}`);
        return headers;
      }
    });

    const refreshResult = await refreshBase(
      {
        url: '/negotiation/negotiations/get_erik_token',
        method: 'POST'
      },
      api,
      extraOptions
    );

    if (refreshResult.data) {
      const { token: newToken, erik_url: newUrl } = refreshResult.data as {
        token: string;
        erik_url: string;
      };
      api.dispatch(setAIAgentCredentials({ token: newToken, erik_url: newUrl }));

      const newRawBase = createRawBase(newToken, newUrl);
      result = await newRawBase(args, api, extraOptions);
    } else {
    }
  }

  if (result?.error?.status === 500) {
    serverError("Errore nel caricamento dei dati", "Se il problema persiste contattaci all' indirizzo support@riskapp.it");
    LogRocket.captureMessage(result?.error?.status.toString());
    console.error(result);
  }

  return result;
};

export const baseLanggraphApiSlice = createApi({
  reducerPath: 'langgraphApiSlice',
  baseQuery: dynamicBaseQuery,
  endpoints: builder => ({})
});

